import { render } from "./manyTeacherUpdateFace.vue?vue&type=template&id=4b3d371c&scoped=true"
import script from "./manyTeacherUpdateFace.vue?vue&type=script&lang=js"
export * from "./manyTeacherUpdateFace.vue?vue&type=script&lang=js"

import "./manyTeacherUpdateFace.vue?vue&type=style&index=0&id=4b3d371c&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3d371c"]])

export default __exports__